import React, { useEffect, useState } from "react";
import Spinner from "react-spinkit";
import QrCode from "../../../../assets/qr-code.png";
import ArrowLeft from "../../../../assets/arrow-left.svg";
import CornersBg from "../../../../assets/corners.svg";
import styles from "./WebToMobile.module.scss";
import { useGlobalContext } from "../../../../scanview/ScanViewerContext";
import { GlobalLogger } from "../../../../scanview/debugLogger";
import QRCode from "react-qr-code";
import { useScanVideoContext } from "../../../../scanview/contexts/ScanVideoContext";

type WebToMobileTexts = {
  title: string;
  instructionsText: string;
  retryButtonText: string;
};

export type WebToMobileHandoffEnabled = boolean | "always";

export type WebToMobileHandOffConfig = {
  enabled?: WebToMobileHandoffEnabled;
  urlBase?: string;
  companyName?: string;
  title?: string;
  instructionsText?: string;
  retryButtonText?: string;
  autoRedirect?: number;
};

const WebToMobile = () => {
  const {
    webToMobileHandoffConfig,
    cardScanApi,
    backsideSupport,
    cameraPermissionModalConfig,
    setShowErrorModal,
    handleRetryButton,
  } = useGlobalContext();
  const { cameraPermissionState } = useScanVideoContext();
  const [webToMobileLink, setWebToMobileLink] = useState("");
  const [webToMobileTexts, setWebToMobileTexts] = useState<WebToMobileTexts>({
    title: "Use your phone to scan your card",
    instructionsText:
      "Scan the QR code with your phone\nFollow the link to securely scan your card.\nReturn here when you're finished.",
    retryButtonText: "Try Again",
  });

  const goBack = () => {
    if (cameraPermissionModalConfig?.enabled) {
      setShowErrorModal((prev) => ({ ...prev, modal: "cameraPermission" }));
    }
  };

  function TextToOrderedList({ text }: { text: string }) {
    if (!text) return null;
    const lines = text.split("\n");

    return (
      <ol>
        {lines.map((line, index) => (
          <li key={index}>{line}</li>
        ))}
      </ol>
    );
  }

  useEffect(() => {
    if (webToMobileHandoffConfig) {
      cardScanApi?.current
        ?.generateMagicLink()
        .then((res: any) => {
          const backside = !!backsideSupport;

          setWebToMobileLink(
            `${webToMobileHandoffConfig?.urlBase}/?token=${res.token}&companyName=${webToMobileHandoffConfig?.companyName}&backsideSupport=${backside}`
          );
        })
        .catch((error: any) => {
          GlobalLogger.error(`Error generating magic link - ${error}`);
          //_handleError(error, stateMachineSend, onError);
        });
    }
  }, [cardScanApi, webToMobileHandoffConfig, backsideSupport]);

  useEffect(() => {
    const texts = {
      ...(webToMobileHandoffConfig?.title
        ? { title: webToMobileHandoffConfig.title }
        : {}),
      ...(webToMobileHandoffConfig?.retryButtonText
        ? { retryButtonText: webToMobileHandoffConfig.retryButtonText }
        : {}),
      ...(webToMobileHandoffConfig?.instructionsText
        ? { instructionsText: webToMobileHandoffConfig.instructionsText }
        : {}),
    };

    if (Object.keys(texts).length) {
      setWebToMobileTexts((prev) => ({
        ...prev,
        ...texts,
      }));
    }
  }, [webToMobileHandoffConfig]);

  return (
    <div className={styles.webToMobileMainContainer}>
      {webToMobileHandoffConfig?.enabled === true &&
        cameraPermissionModalConfig?.enabled &&
        cameraPermissionState !== "granted" && (
          <button className={styles.goBackBtn} onClick={goBack} role="button">
            <img src={ArrowLeft} alt="Blue arrow pointing to the left" /> Back
          </button>
        )}
      <div className={styles.titleRow}>
        <img className={styles.icon} src={QrCode} alt="Qr code with sparkles" />
        <h2>{webToMobileTexts.title}</h2>
      </div>
      <div className={styles.qrCodeContainer}>
        <img
          className={styles.corners}
          src={CornersBg}
          alt="four blue corners"
        />
        <div className={styles.qrContainer}>
          {webToMobileLink ? (
            <QRCode
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={webToMobileLink}
              viewBox={`0 0 256 256`}
            />
          ) : (
            <Spinner
              {...{
                name: "ball-spin-fade-loader",
                fadeIn: "none",
                color: "#000",
              }}
            />
          )}
        </div>
      </div>
      <div className={styles.stepsContainer}>
        {webToMobileTexts.instructionsText && (
          <TextToOrderedList text={webToMobileTexts.instructionsText} />
        )}
      </div>
      {cameraPermissionState === "granted" && (
        <button className={styles.tryAgainBtn} onClick={handleRetryButton}>
          {webToMobileTexts.retryButtonText}
        </button>
      )}
    </div>
  );
};

export default WebToMobile;
